<template>
  <div class="app-container">
    <HeaderComponent />
    
    <main>
      <router-view />
    </main>

    <FooterComponent />
  </div>
</template>

<script setup>
import HeaderComponent from './components/header&footer/HeaderComponent.vue'
import FooterComponent from './components/header&footer/FooterComponent.vue'
</script>

<style>
*{
  font-family: "Noto Sans Lao", sans-serif;
}
* {
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Noto Sans Lao', sans-serif;
  background-color: #f5f8fa;
}

#app {
  min-height: 100vh;
}
/*body {
  margin: 0;
  
  padding: 0;
  box-sizing: border-box;
  font-family: "Noto Sans Lao", "Saysettha OT", sans-serif;
  background-color: #f5f8fa;
}*/

/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>